import { Component, Entity2D, clamp } from '../../../odie';
import { CountBlockOptionDef } from '../../defs/block';
import { MagicBunniesBlockProps } from './MagicBunniesBlock';
import { MagicBunniesBlockView } from './MagicBunniesBlockView';

export type MagicBunniesBlockComponentOptions = {
  props: MagicBunniesBlockProps;
  option?: number;
};

export class MagicBunniesBlockComponent implements Component {
  public static readonly NAME = 'blockMagicBunnies';
  public entity!: Entity2D;
  public view!: MagicBunniesBlockView;
  public gotHit = false;
  private props!: MagicBunniesBlockProps;

  public init(args: MagicBunniesBlockComponentOptions): void {
    this.props = args.props;
    this.view = new MagicBunniesBlockView(
      args.props,
      this.optionToCount(args.option ?? 0),
    );
    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    return this.countToOption(this.count) ?? 0;
  }

  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }

  private optionToCount(option: number) {
    const options = this.props.options as CountBlockOptionDef[];
    if (option < 0 || option >= options.length) option = 0;
    return options[option].count;
  }

  private countToOption(count: number) {
    const options = this.props.options as CountBlockOptionDef[];
    const index = options.findIndex((opt) => {
      return opt.count === count;
    });
    return clamp(index, 0, options.length - 1);
  }
}
